import React, { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';

import SearchResult from "../../components/Books/SearchResult";
import Loader from '../../components/Loader';
import Pagination from '../../components/Pagination';
import NotFound from '../../components/NotFound';
import sortBooks from '../../components/Books/SortBooks';

import { useQuickSearch } from "../../hooks/Hooks";

export default function QuickSearch() {
    document.title = 'Recherche - Suplib';
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [sortType, setSortType] = useState('AZ');
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const query = searchParams.get('q');
    const { results: books, isLoading } = useQuickSearch(query);

    const booksWithCover = useMemo(() => books ? books.filter(book => book.cover_i) : [], [books]);

    useEffect(() => {
        setTotalPages(Math.ceil(booksWithCover.length / 9));
    }, [booksWithCover]);

    const handleSortChange = (event) => {
        setSortType(event.target.value);
    };

    const sortedBooks = sortBooks(booksWithCover, sortType);

    if (isLoading) {
        return <Loader/>;
    }

    if (sortedBooks.length === 0) {
        return <NotFound query={query} />;
    }

    return (
        <>
            <h2 className="text-2xl font-extrabold mt-5 text-center">
                Résultat de votre recherche pour : "{query}"
            </h2>

            <form className="max-w-sm mx-auto mt-10">
                <label htmlFor="underline_select" className="sr-only">Sélectionnez une option</label>
                <select onChange={handleSortChange} id="underline_select" className="block py-2.5 px-0 w-full text-sm bg-transparent border-0 border-b-2 border-gray-200 appearance-none focus:outline-none focus:ring-0 peer">
                    <option value="">Sélectionnez une option de tri</option>
                    <option value="AZ">Trier de A à Z</option>
                    <option value="ZA">Trier de Z à A</option>
                    <option value="LowToHighRate">Moins bien noté au mieux noté</option>
                    <option value="HighToLowRate">Mieux noté au bien moins noté</option>
                </select>
            </form>

            <div className="flex flex-col sm:flex-row items-center justify-center mt-10">
                <SearchResult results={sortedBooks.slice((page - 1) * 9, page * 9)} />
            </div>

            <Pagination page={page} totalPages={totalPages} setPage={setPage} />
        </>
    );
}